import type { ReactNode } from "react";

interface Props {
	title: string;
	children?: ReactNode;
}

export function ExplanationButton({ title, children }: Props) {
	const words = title.split(" ");
	const lastWord = words.pop();
	const rest = words.join(" ");

	return (
		<>
			<span>{rest} </span>

			<span className="whitespace-nowrap">
				{lastWord}
				&nbsp;
				{children}
			</span>
		</>
	);
}
